import { Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import { Input } from 'formik-antd';
import { FormInput, Box } from 'atoms';

const { Title } = Typography;

export function LRVehicleDetails({ isEditMode }) {
	return (
		<Box padding="1rem">
			<div style={{ textAlign: 'center' }}>
				<Title level={4}>Vehicle</Title>
			</div>
			<Row>
				<Col span={24}>
					<FormInput name="vehicle_number" label="Vehicle Number">
						<Input
							name="vehicle_number"
							placeholder="Vehicle Number"
							disabled={!isEditMode}
						/>
					</FormInput>
				</Col>
			</Row>
			<Row>
				<Col span={24}>
					<FormInput name="driver_name" label="Driver Name">
						<Input
							name="driver_name"
							placeholder="Driver Name"
							disabled={!isEditMode}
						/>
					</FormInput>
				</Col>
			</Row>
		</Box>
	);
}

LRVehicleDetails.propTypes = {
	isEditMode: PropTypes.bool,
};
